export default "__VITE_ASSET__CdQIUW0W__"